import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';
export const CONTROL = 'control';

export const getExperimentCohort = ({ fireExposure } = { fireExposure: false }) => {
	try {
		const [expConfig, fireExperimentExposure] = UNSAFE_noExposureExp('invite_on_link_insert_v4-2');
		fireExposure && fireExperimentExposure();
		return expConfig.get('cohort', 'not-enrolled');
	} catch {
		return NOT_ENROLLED;
	}
};

export const isExperimentEnabled = () => getExperimentCohort({ fireExposure: false }) === VARIATION;
